import React, { useState } from 'react';
import './LanguageQuestion.css'; // Import a CSS file for custom styles
import ErrorComponent from './ErrorMessage';
import Questionnaire from '../Questionnaire/Questionnaire/Questionnaire';
import { Button, Card } from 'react-bootstrap';

const LanguageQuestion = ({ pages, Latitude, Longitude, wholeWord ,translations}) => {
    const languages = pages?.translations?.languages || [];
    // const languages = [
    //     "English", "Hindi", "Tamil", "Bengali",
    //     "Oriya", "Marathi", "Assamese", "Telugu",
    //     "Gujarati", "Kannada", "Malayalam"
    // ];
    const [showError, setShowError] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    const [saveSuccess, setSaveSuccess] = useState(false);
  const [updatedPages, setUpdatedPages] = useState(pages);
    const handleLanguageChange = (language) => {
        setShowError(false);
        setSelectedLanguage(language);
    };
const applyTranslations = () => {
  if (!pages || !translations || !selectedLanguage) return pages;

  const newPages = JSON.parse(JSON.stringify(pages)); // Deep copy to avoid mutation
  const langKeys = [selectedLanguage, selectedLanguage.toUpperCase(), selectedLanguage.toLowerCase()];

  newPages.pages.forEach((page) => {
    page.elements.forEach((element) => {
      const translatedElement = translations.pages?.find(
        (t) => t.id === element.id || t.tempId === element.tempId
      );

      if (!translatedElement) return;

      const translation = langKeys.reduce(
        (acc, key) => acc || translatedElement.translations?.[key],
        null
      );

      if (!translation) return;

      element.questionTextTrans = translation.questionText || element.questionText;
      element.questionDescriptionTrans = translation.questionDescription || element.questionDescription;
      element.requiredErrorTextTrans = translation.requiredErrorText || element.requiredErrorText;
      element.placeHolderTextTrans = translation.placeHolderText || element.placeHolderText;

      if (Array.isArray(element.choices) && Array.isArray(translation.choices)) {
        element.choices = element.choices.map((choice, idx) => {
          const translatedChoice = translation.choices[idx];

          if (typeof choice === "string") choice = { text: choice };

          return translatedChoice
            ? { ...choice, textTrans: translatedChoice.text || choice.text }
            : choice;
        });
      }
    });
  });

  return newPages;
};


 const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedLanguage) {
            setShowError(true);
            return;
        }

        const translatedPages = applyTranslations();
       
         setUpdatedPages(translatedPages);
        setSaveSuccess(true);
      
    };
  if (saveSuccess) {
        // When language is selected, render Questionnaire with original behavior
        return (
            <Questionnaire
                pages={updatedPages}
                Latitude={Latitude}
                Longitude={Longitude}
                wholeWord={wholeWord}
                hasTranslations={true}
            />
        );
    }

   return (
        <div style={{ position: 'relative', paddingBottom: '60px' }}>
            {/* Header - same as in Questionnaire */}
             <div
    style={{
      ...pages.header.surveyheadingBackground,
      display: "flex",
      alignItems: "center", // ✅ centers logo vertically with title+desc
      justifyContent: "space-between",
      padding: "10px 20px",
    }}
  >
     <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: pages.header.titlePosition || "center",
        justifyContent: "center",
        flex: 1,
        color: pages.header.surveyheadingForeground?.color || "#fff",
      }}
    >
      <p
        style={{
          ...pages.header.surveyheadingForeground,
          
          margin: 0,
          fontSize: "28px",
        }}
      >
        {pages?.header.title}
      </p>
      <p
        style={{
          ...pages.header.surveyheadingForeground,
          margin: 0,
          fontSize: "20px",
        }}
      >
        {pages?.header.description}
      </p>
    </div>
                  <img
      src={pages.header.logo}
      style={{
        height: "45px",
        width: "auto",
        objectFit: "contain",
      
      }}
    />
                
            </div>

            {/* Language selection form */}
            <div style={{ marginBottom: '60px' }} className="responsive-padding">
                <Card className='mt-3'>
                <Card.Body>
                <form onSubmit={handleSubmit}>
                    <div className="row align-items-start mt-3 me-3 mb-3 desktop-margin-left">
                        <div className="col-11">
                            <label className="mb-2">
                                <b>Q. Please select your preferred language</b>
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                        </div>
                        {showError && <ErrorComponent message="Answer cannot be empty!!" />}

                        {languages.map((language, index) => (
                            <div
                                className={`col-md-5 col-sm-5 col-5 m-2 language-box ${selectedLanguage === language}`}
                                key={index}
                                onClick={() => handleLanguageChange(language)}
                            >
                                <label htmlFor={`radio-Q1-${index}`} className="option-item-text">
                                    <div className="form-check d-flex align-items-center justify-content-center h-100">
                                        <input
                                            name="Q1"
                                            type="radio"
                                            id={`radio-Q1-${index}`}
                                            className="form-check-input"
                                            value={language}
                                            checked={selectedLanguage === language}
                                            onChange={() => handleLanguageChange(language)}
                                        />
                                        <label
                                            title=""
                                            htmlFor={`radio-Q1-${index}`}
                                            className="form-check-label text-center m-0 ms-2"
                                        >
                                            {language}
                                        </label>
                                    </div>
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex justify-content-center">
                        <button type="submit" className="btn btn-primary">
                            Submit
                        </button>
                    </div>
                </form>
                </Card.Body></Card>
            </div>

            {/* Footer without progress bar */}
            <div className="d-flex justify-content-between" style={{
                position: 'fixed',
                bottom: "0",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
                width: "100%",
                backgroundColor: pages.footer.footerBackgroundcolor,
            }}>
                {/* <Button 
                    style={{
                        ...pages.footer.previousbuttonstyle,
                        marginLeft: '15px',
                        visibility: "hidden"
                    }}
                >
                    {pages.footer.previousbuttonlabel}
                </Button> */}
            </div>
        </div>
    );

};

export default LanguageQuestion;
